<div class="aeg-admin-invoice-round-tab">
    <vl-data-table class="aeg-datatable" :mod-zebra="!emptyState || isLoading">
        <thead class="aeg-datatable-header aeg-invoice-round-header">
        <tr>
            <th>Datum</th>
            <th>Facturatieperiode</th>
            <th>Service</th>
            <th>Status</th>
            <th>Type</th>
            <th>Aantal facturen</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="isLoading">
            <td colspan="6">
                <div class="aeg-datatable__loading">
                    <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b."/>
                </div>
            </td>
        </tr>
        <tr v-else-if="emptyState">
            <td colspan="6">
                <div class="aeg-datatable__empty">
                    Er zijn nog geen facturatierondes.
                </div>
            </td>
        </tr>
        <tr v-else v-for="invoiceRound in invoiceRounds" :key="invoiceRound.id">
            <td>{{ formatDateTime(invoiceRound.date) }}</td>
            <td>{{ formatDate(invoiceRound.startDate)}} - {{ formatDate(invoiceRound.endDate) }}</td>
            <td class="uppercase">{{ invoiceRound.service }}</td>
            <td>{{ invoiceRound.state }}</td>
            <td>{{ invoiceRound.type }}</td>
            <td>{{ invoiceRound.invoiceCount }}</td>
        </tr>
        </tbody>
    </vl-data-table>
</div>